type AffiliateData = {
  awc: string
  affiliateMarker: string
}

export const getAffiliateDataFromCookie = (cookie: string): AffiliateData => {
  const cookies = cookie.split('; ')

  const awcCookies = cookies.filter((cookie) => cookie.startsWith('_aw_sn_'))

  return {
    awc: awcCookies.at(-1)?.split('=')[1] ?? '',
    affiliateMarker:
      cookies
        .find((cookie) => cookie.startsWith('affiliateMarker='))
        ?.split('=')[1] ?? '',
  }
}
